import { EVENT_DEFAULT_ERROR_MESSAGE } from '../constants';
import { ExpressCheckoutConditionsApiResponse } from '../models/expressCheckout';
import { fetchV3WithTranslateServerErrors } from './base';
import { getExpressCheckoutConditionsUrl } from './constants';

export const EXPRESS_CHECKOUT_CONDITIONS_ERROR_SPEC = {
    default: () => EVENT_DEFAULT_ERROR_MESSAGE,
};

export const getExpressCheckoutConditions = (eventId: string) => {
    const expressCheckoutConditionsEndpoint =
        getExpressCheckoutConditionsUrl(eventId);

    return fetchV3WithTranslateServerErrors<ExpressCheckoutConditionsApiResponse>(
        EXPRESS_CHECKOUT_CONDITIONS_ERROR_SPEC,
        expressCheckoutConditionsEndpoint,
        {
            method: 'GET',
        },
    );
};
